var p="@hpstellar/pdp/configurations";export{p as configurationsTestId};
